import React, { useRef } from 'react';
import ReactDOM from 'react-dom'

import Backdrop from './backDrop';
import { CSSTransition } from 'react-transition-group';

import './courseModal.css';


 const ModalOverlay = React.forwardRef((props, ref) => {

    const content = (
        <main ref={ref} className={`coModal ${props.className}`} style={props.style}>
            <div className={`coModal-container ${props.containerClass}`}>
            {/* <header className={`coModal-header ${props.headerClass}`} >
                <h2>{props.header}</h2>
            </header> */}
            {/* <form onSubmit={props.onSubmit ? props.onSubmit : event => event.preventDefault()}> */}
                <div className={`coModal-content ${props.contentClass}`}>
                    {props.children}
                </div>
                <footer className={`coModal-footer ${props.footerClass}`}>
                    {props.footerClass}
                </footer>
            {/* </form> */}
            </div>
        </main>
    )
    return ReactDOM.createPortal(content, document.getElementById('courseModal-hook'))
 });


const CourseModal = props => {
    const nodeRef = useRef(null)
    return (
        <React.Fragment>
            {props.show && <Backdrop onClick={props.onCancel}/>}
            <CSSTransition 
                in={props.show}
                mountOnEnter
                unmountOnExit
                timeout={2}
                classNames='coModal'
                nodeRef={nodeRef}
            >
                <ModalOverlay {...props} ref={nodeRef}/>

            </CSSTransition>
        </React.Fragment>
    )
}

export default CourseModal;